var mainNavigationRef;

try {
	mainNavigationRef = new MainNavigation();
	mainNavigationRef.Setup();
}
catch (ex) {
	console.error("Error initializing main navigation: " + ex.message);
}

try {
	var topBar = new TopBar();
	topBar.Fill();
}
catch (ex) {
	console.error("Error initializing top bar: " + ex.message);
}

try {
	SWSearch.Relocate();
}
catch (ex) {
	console.error("Error relocating search: " + ex.message);
}